import { render, staticRenderFns } from "./Body.vue?vue&type=template&id=0a7bc7dc&scoped=true"
import script from "./Body.vue?vue&type=script&lang=js"
export * from "./Body.vue?vue&type=script&lang=js"
import style0 from "./Body.vue?vue&type=style&index=0&id=0a7bc7dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7bc7dc",
  null
  
)

export default component.exports